import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';

/** Marks a room every new demo prospect gets. */
export function DemoRoomBadge() {
    const { t } = useTranslation();
    return (
        <Badge variant="secondary" className="shrink-0" title={t('ADMIN_SPACES.DEMO.HINT')}>
            {t('ADMIN_SPACES.DEMO.BADGE')}
        </Badge>
    );
}
